import styled from 'styled-components';

// Import styles
import { ItemDetailsHoverStyle } from 'components/views/vod/components/ItemDetails/styles';

// Import assets
import SliderItemPlaceholder from 'assets/images/slider_item_placeholder.png';

// API-URL
const { REACT_APP_API_URL } = process.env;

export const SliderItem = styled.div`
	position: relative;
	width: ${({ width }) => width}px;
	height: ${({ height }) => height}px;
	background: no-repeat url('${REACT_APP_API_URL}/assets/${({ id }) =>
	id}/poster'), no-repeat url(${SliderItemPlaceholder});
	background-size: ${({ width }) => width}px ${({ height }) => height}px;
	cursor: pointer;
	overflow: hidden;
`;

export const BgGradientStyled = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
	background: linear-gradient(
		205deg,
		rgba(47, 215, 255, 1) 12%,
		rgba(23, 129, 247, 1) 75%
	);
	opacity: 0.6;
	z-index: -1;
`;

export const Content = styled.div`
	position: relative;
	z-index: 0;
	height: 100%;
	width: 100%;
	padding: 0.3rem;

	${ItemDetailsHoverStyle}
`;
